import React from "react";
import { useLocation } from "react-router-dom";
import CloudSecurityCenter from "./cloud/CloudSecurityCenter.jsx";
import AzureDashboardLegacy from "./s-item-3-2-azure-Legacy.jsx";

const AzureDashboard = () => {
  const { search } = useLocation();
  const requestedView = new URLSearchParams(search).get("cloudDashboard");
  const v3Enabled =
    String(process.env.REACT_APP_CLOUD_DASHBOARD_V3).toLowerCase() === "true";
  const showV3 =
    requestedView === "v3" || (requestedView !== "legacy" && v3Enabled);

  return showV3 ? (
    <CloudSecurityCenter initialProviderScope="azure" />
  ) : (
    <AzureDashboardLegacy />
  );
};

export default AzureDashboard;
